module.exports = __webpack_public_path__ + "static/media/SOLICITUD CARATULA Satelital 234-2020.7b95325f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/SOLICITUD CARATULA Satelital 234-2020.pdf
// module id = 946
// module chunks = 0